var map = {
	"./01.mp3": "f7b0",
	"./02.mp3": "5f5c",
	"./1.mp3": "0ad0",
	"./1.png": "0ca1",
	"./2.mp3": "0689",
	"./3.mp3": "3c92",
	"./Ranking.png": "32e4",
	"./aaa.png": "dbfb",
	"./add.png": "d1da",
	"./add2.png": "9c36",
	"./avatar/1.jpg": "52f0",
	"./avatar/10.jpg": "39c6",
	"./avatar/2.jpg": "96f2",
	"./avatar/3.jpg": "80f2",
	"./avatar/4.jpg": "bfdd",
	"./avatar/5.jpg": "1965",
	"./avatar/6.jpg": "b00a",
	"./avatar/7.jpg": "3d27",
	"./avatar/8.jpg": "42c9",
	"./avatar/9.jpg": "68dd",
	"./beibao.png": "3cd5",
	"./beibao_sel2.png": "ba6b",
	"./bg-ByBHE7gk.png": "ba77",
	"./bottom-active.png": "d6ab",
	"./bottom-bg.png": "b510",
	"./box_moeny_bg.png": "70ec",
	"./box_open.png": "36e6",
	"./btn_bg.png": "3c57",
	"./bushiyingjia.png": "89e0",
	"./c9bd5d06-2d1b-4e6f-a5e2-a3cdd00872ac.71ee8.png": "ea25",
	"./createRoom.png": "6ce1",
	"./creatroom/1.png": "66bf",
	"./creatroom/16.png": "1843",
	"./creatroom/17.png": "dd80",
	"./creatroom/18.png": "e219",
	"./creatroom/19.png": "d10f",
	"./creatroom/2 - 副本.png": "c900",
	"./creatroom/2.png": "7a02",
	"./creatroom/20.png": "a38f",
	"./creatroom/21.png": "bde0",
	"./creatroom/22.png": "36a6",
	"./dengdai.png": "3336",
	"./dream-bg.png": "0924",
	"./dream-btn-bg-active.png": "7205",
	"./dream-btn-bg.png": "0d9e",
	"./dream.mp4": "035d",
	"./font/YouSheBiaoTiHei-2.ttf": "2e25",
	"./font/demo.css": "4170",
	"./font/demo_index.html": "5297",
	"./font/iconfont": "32aa",
	"./font/iconfont.css": "a342",
	"./font/iconfont.js": "32aa",
	"./font/iconfont.json": "50e0",
	"./font/iconfont.ttf": "72fc",
	"./font/iconfont.woff": "35fc",
	"./font/iconfont.woff2": "a89a",
	"./font/tuiguangbg.png": "9c71",
	"./game_bg.png": "9acd",
	"./gen-box-bg-C9N-vsd0.png": "a338",
	"./goods-bg-W3mkDdCy.png": "4a0b",
	"./guanzhan.png": "d1a2",
	"./guanzhan2.png": "2971",
	"./head-bg.png": "ee0d",
	"./home (1).png": "b3dc",
	"./home.mp3": "63e8",
	"./home.png": "fbf5",
	"./home.webp": "21f4",
	"./home/100.png": "9cb0",
	"./home/a1.png": "9e9d",
	"./home/a2.png": "a36f",
	"./home/a3.png": "4c43",
	"./home/a4.png": "17c3",
	"./home/a5.png": "dc99",
	"./home/battle-text.png": "a79b",
	"./home/battle.png": "d151",
	"./home/bj.png": "0227",
	"./home/bj2.png": "3b7c",
	"./home/bottom.png": "04d5",
	"./home/box-text.png": "b4ba",
	"./home/box.png": "ce1e",
	"./home/exponent-text.png": "278e",
	"./home/exponent.png": "e819",
	"./home/home-content-bg.png": "63aa",
	"./home/jb.png": "7979",
	"./home/jifen.png": "7c1e",
	"./home/jinbi.png": "8cf7",
	"./home/left1.png": "5048",
	"./home/lucky-text.png": "de9a",
	"./home/lucky.png": "a0d3",
	"./home/roll-text.png": "fc24",
	"./home/roll.png": "5832",
	"./home/ss.png": "5d98",
	"./home/t1.png": "a405",
	"./home/t2.png": "80d2",
	"./home/t3.png": "9c58",
	"./home/t4.png": "ad9e",
	"./home/t5.png": "2504",
	"./home/top.png": "14d1",
	"./home/ts1.png": "e35a",
	"./home/ts2.png": "9861",
	"./home/ts3.png": "85b6",
	"./home/ts4.png": "5e45",
	"./home/ts5.png": "9a15",
	"./home/tx.png": "2bd4",
	"./home/xx.png": "4639",
	"./home/xy.gif": "031c",
	"./home/xy.png": "f421",
	"./home/yqm.png": "d5b2",
	"./home2.png": "517f",
	"./home_sel2.png": "0530",
	"./hong.png": "b8de",
	"./hudong.png": "c50e",
	"./image/avatar/0e491040df45832cee35314f374c9b14.jpg": "3c72",
	"./image/avatar/325ab15e8ecfeb7113edc9ebaeb6bb73.jpg": "5034",
	"./image/avatar/3d7afd41a03e69dcbdf75a17cb5bd0ea.jpg": "397a",
	"./image/avatar/68f01a004889bffbd65019ef28d021b5.jpg": "5428",
	"./image/avatar/884b1494c29dce6b4aad2161a9b27055.jpg": "693d0",
	"./image/avatar/a5b3397dc886cee5a91dca5921e2679b.jpg": "e6e6",
	"./image/avatar/ac464e5bf9d9a679b2bcec70441176e0.jpg": "185b",
	"./image/avatar/b56f2c46b0075ab0627997d8b79fb766.jpg": "f660",
	"./image/avatar/c08c85b9f4df9573116ae393d6292ab9.jpg": "ac62",
	"./image/avatar/cf74fa052c5aa129bcf958ca333de148.jpg": "a030",
	"./image/close.svg": "27ae",
	"./image/gongan.png": "7dc4",
	"./image/index/logo.png": "373a",
	"./image/loggin_button.png": "ed90",
	"./image/logo_login.png": "67a4",
	"./image/pk_watch.png": "0770",
	"./image3/blindBox/dljl-not-select.png": "f787",
	"./image3/blindBox/dljl-select.png": "91c6",
	"./image3/blindBox/progress-add.png": "2136",
	"./image3/blindBox/progress-minus.png": "22a9",
	"./image3/blindBox/progress-ring.png": "9d1c",
	"./image3/blindBox/progress-ring1.png": "a149",
	"./image3/blindBox/progress-strip.png": "92db",
	"./image3/blindBox/progress-switch.png": "4b61",
	"./image3/blindBox/question.png": "d4b7",
	"./image3/blindBox/sjwb-question.png": "b84c",
	"./image3/blindBox/sjwbBack.png": "196a",
	"./image3/high_time/1.png": "da7c",
	"./image3/high_time/2.png": "ff7a",
	"./image3/high_time/3.png": "c9a0",
	"./image3/high_time/dljl-not-select.png": "8453",
	"./image3/high_time/headBack.png": "2fd1",
	"./image3/high_time/listBlue.png": "65b8",
	"./image3/high_time/listDarkBlue.png": "4836",
	"./image3/high_time/listPurple.png": "82b8",
	"./image3/high_time/shopBlue.png": "852a",
	"./image3/high_time/shopDarkBlue.png": "ae2e",
	"./image3/high_time/shopPurple.png": "63c4",
	"./image3/home/InvitationCode.png": "ca3c",
	"./image3/home/InvitationCodeIcon.png": "6c68",
	"./image3/home/InvitationCodeText.png": "49ef",
	"./image3/home/accountRecords.png": "f67e",
	"./image3/home/backpackBtn.png": "2cd7",
	"./image3/home/btnBack.png": "5fc8",
	"./image3/home/butCar.png": "c2dc",
	"./image3/home/copy.png": "df0f",
	"./image3/home/edit.png": "1f32",
	"./image3/home/exitButton.png": "b29f",
	"./image3/home/highlight.png": "1be0",
	"./image3/home/information.png": "2cb1",
	"./image3/home/leftArrow.png": "a833",
	"./image3/home/listBack.png": "3cfb",
	"./image3/home/passwordModification.png": "d7ac",
	"./image3/home/prizeDraw.png": "2533",
	"./image3/home/rankingOne.png": "f239",
	"./image3/home/rankingThree.png": "65a0",
	"./image3/home/rankingTwo.png": "fd6f",
	"./image3/home/selectShop.png": "58a85",
	"./image3/home/settingBack.png": "cf15",
	"./image3/home/sortBack.png": "f95e",
	"./image3/home/transactionLink.png": "9d06",
	"./image3/home/unpackingBack.png": "a8c9",
	"./image3/home/vipBtn.png": "0758",
	"./image3/recharge/rechargeNotSelect.png": "2d14",
	"./image3/recharge/rechargeSelect.png": "1beb",
	"./image3/share/copyLinkBack.png": "a7a2",
	"./image3/share/generateBack.png": "b743",
	"./image3/share/notSelectedBack.png": "9e20",
	"./image3/share/selectBack.png": "23ed",
	"./image3/share/shareBack.png": "ff0c",
	"./image3/user/headBack.png": "38fd",
	"./images/a_m_1.png": "ea2a",
	"./images/a_m_2.png": "9f0f",
	"./images/active-tab.png": "e341",
	"./images/add_btn.png": "647a",
	"./images/alipay.png": "d342",
	"./images/anim_bg0.gif": "16d4",
	"./images/anim_bg0.png": "3465",
	"./images/anim_bg1.gif": "0254",
	"./images/anim_bg1.png": "80d0",
	"./images/app_dl_bg2.png": "7afb",
	"./images/app_ft_1.png": "f5cf",
	"./images/app_ft_2.png": "ca28",
	"./images/app_ft_2_1.png": "0d93",
	"./images/app_ft_4.png": "6aa4",
	"./images/app_header.png": "1f73",
	"./images/avata_select.png": "e9d8",
	"./images/avatar-bg.png": "0850",
	"./images/avatar-item-sel.png": "7791",
	"./images/avatar-item.png": "fd3d",
	"./images/avatar-list-wrap.png": "ca48",
	"./images/avatar_outer.png": "fc7f",
	"./images/avatar_outer_box2.png": "8c98",
	"./images/b-price-bg.png": "d39c",
	"./images/back-icon.png": "3820",
	"./images/balance.png": "0d11",
	"./images/balance1.png": "5992",
	"./images/balance2.png": "5eea",
	"./images/balance3.png": "a17f",
	"./images/balance_bg.png": "5e3a",
	"./images/balance_btn.png": "bfc6",
	"./images/banner_bkg.png": "581a",
	"./images/bar_active_bg3.png": "17a7",
	"./images/bars.png": "12f22",
	"./images/battle_empty.png": "f646",
	"./images/battle_no_join_avatar.png": "1f0b",
	"./images/battle_room_view.png": "8bba",
	"./images/big_btn_1.png": "0de9",
	"./images/big_btn_2.png": "7749",
	"./images/bind_btn.png": "003f",
	"./images/bind_user_info_box_bg.png": "7eb5",
	"./images/bk_blue.png": "966a",
	"./images/bk_blue1.png": "8b8a",
	"./images/bk_golden.png": "2bf8",
	"./images/bk_golden1.png": "fc93",
	"./images/bk_purple.png": "1717",
	"./images/bk_purple1.png": "b44b",
	"./images/bk_red.png": "47af",
	"./images/bk_red1.png": "370d",
	"./images/blue-line.png": "d3f2",
	"./images/blue.png": "4901",
	"./images/bottom-icon.png": "48a5",
	"./images/bottom_bg.png": "d510",
	"./images/bottom_line.png": "609f",
	"./images/bottom_line_1.png": "3f29",
	"./images/bottom_nav_item.png": "2743",
	"./images/bottom_outer_box_bg.png": "d2b7",
	"./images/bottom_tab_item_sel.png": "206a",
	"./images/box-1.gif": "b5753",
	"./images/box-2.gif": "fb9e",
	"./images/box-3.gif": "4044",
	"./images/box-4.gif": "5c2e",
	"./images/box-5.gif": "b877",
	"./images/box-classic.png": "6ecdc",
	"./images/box-fight.png": "808f",
	"./images/box-items-icon.png": "7293",
	"./images/box-lucky.png": "3d04",
	"./images/box_anim_bk1.png": "8e3a",
	"./images/box_anim_bk2.png": "1a67",
	"./images/box_anim_bk21.png": "2a73",
	"./images/box_anim_bk3.png": "0baa",
	"./images/box_anim_bk4.png": "4253",
	"./images/box_bg.png": "5f53",
	"./images/box_bg_1.png": "c7b5",
	"./images/box_bg_10.png": "e386",
	"./images/box_bg_11.png": "67e2",
	"./images/box_bg_1_1.png": "efb1",
	"./images/box_bg_2.png": "7c67",
	"./images/box_bg_3.png": "3293",
	"./images/box_bg_5.png": "bcd9",
	"./images/box_bg_6.png": "40eb",
	"./images/box_bg_7.png": "63bb",
	"./images/box_bg_8.png": "2caf",
	"./images/box_bk_line.gif": "bca6",
	"./images/box_border.png": "6704",
	"./images/box_ic_2.png": "8462",
	"./images/box_item_bg1.png": "c066",
	"./images/box_sel.png": "d9d7",
	"./images/box_shadow_bg_1.png": "77b7",
	"./images/box_shadow_bg_2.png": "565d",
	"./images/btm-mask.png": "0076",
	"./images/btm_bg_1.png": "0dde",
	"./images/btm_bg_2.png": "c097",
	"./images/btm_bg_3.png": "3709",
	"./images/btn_1-active.png": "0797",
	"./images/btn_bg1.png": "8341",
	"./images/btn_bg2.png": "80bd",
	"./images/btn_bg3.png": "4c72",
	"./images/btn_sel_bg.png": "0660",
	"./images/buy_back_btn.png": "2ffa",
	"./images/c_logo.png": "fe91",
	"./images/cancel-all.png": "016c",
	"./images/cart-active-icon.png": "f33b",
	"./images/cart-icon.png": "9ad8",
	"./images/charge-icon.png": "37fc",
	"./images/chart_bg2.png": "ea30",
	"./images/checkIcon.png": "9def",
	"./images/clear-all-btn.png": "b8fc",
	"./images/clock_bg1.png": "2dd0",
	"./images/close-bg.png": "ec07",
	"./images/code.png": "50dc",
	"./images/code_box_bg.png": "982b",
	"./images/color_blue.png": "6220",
	"./images/color_golden.png": "5890",
	"./images/color_purple.png": "e7d1",
	"./images/color_red.png": "db9c",
	"./images/content-top.png": "ff0b",
	"./images/copy-icon.png": "ade9",
	"./images/copy1-icon.png": "b756",
	"./images/createRollRoom.png": "77af",
	"./images/create_bg6.png": "a219",
	"./images/create_btn.png": "c62f",
	"./images/create_btn1.png": "fa52",
	"./images/create_btn2.png": "859c",
	"./images/create_code_btn.png": "007a",
	"./images/create_recharge_btn.png": "3d2f",
	"./images/create_take_back_btn.png": "5c52",
	"./images/cur-data-red.png": "ad62",
	"./images/cur-data.png": "492e",
	"./images/cur_rank_bg.png": "c781",
	"./images/data_bg_b.png": "36c7",
	"./images/data_bg_g.png": "a4e3",
	"./images/data_bg_r.png": "850e",
	"./images/default-header.png": "70e3",
	"./images/default_avatar.jpg": "7050",
	"./images/del-tag.png": "b4df",
	"./images/del_btn2.png": "d775",
	"./images/del_confirm_btn.png": "2da9",
	"./images/del_confirm_btn_1.png": "5609",
	"./images/detail-btn-bottom.png": "e0ad",
	"./images/detail-btn-top.png": "d64f",
	"./images/dialog_bg_1.png": "c842",
	"./images/digit_2.png": "7679",
	"./images/digit_3.png": "556e",
	"./images/dot.png": "dab6",
	"./images/dot1.png": "ed9d",
	"./images/down-icon.png": "86a3",
	"./images/down_bg6.png": "ae24",
	"./images/drop-info-all.png": "c0c4",
	"./images/drop_blue.png": "29f7",
	"./images/drop_golden.png": "373f",
	"./images/drop_purple.png": "04be",
	"./images/drop_red.png": "027f",
	"./images/edit-icon.png": "fae7",
	"./images/end_mask.png": "1225",
	"./images/error_message_bg.png": "f311",
	"./images/error_tip_box.png": "a9eb",
	"./images/exit_btn.png": "99a0",
	"./images/fail-msg.png": "83c4",
	"./images/filter_item.png": "a07d",
	"./images/filter_item_sel.png": "50c3",
	"./images/forward-icon.png": "cf61",
	"./images/frag_img1.gif": "0df5",
	"./images/fu_account.png": "df34",
	"./images/gift.png": "f9fd",
	"./images/give_btn.png": "a708",
	"./images/goods_list_bk1.png": "49d8",
	"./images/gradient_bg.png": "3205",
	"./images/h5-bg.png": "4c0c",
	"./images/head-index-box.png": "1258",
	"./images/head_bk.png": "b93d",
	"./images/header-bg-1.png": "1b12",
	"./images/header-bg-2.png": "5c2f",
	"./images/header-bg.png": "206d",
	"./images/header-bg2.png": "cb12",
	"./images/home-list-icon.png": "ba75",
	"./images/home.webp": "1e05",
	"./images/home/1.png": "d5e8",
	"./images/home/2.png": "f7a0",
	"./images/home/3.png": "877d",
	"./images/home/4.png": "cf25",
	"./images/home/5.png": "e4d5",
	"./images/home/6.png": "5082",
	"./images/home/bj.png": "14c3b",
	"./images/home/roll.png": "a491",
	"./images/home_bg.gif": "7194",
	"./images/icon-circle.png": "320e",
	"./images/icon-circle2.png": "f37b",
	"./images/icon-detail.png": "606e",
	"./images/icon-down.png": "61bb",
	"./images/icon-gun.png": "109b",
	"./images/icon-join.png": "ad11",
	"./images/icon1.png": "7d93",
	"./images/icon2.png": "9aa4",
	"./images/img_bg_sel.gif": "e53c",
	"./images/img_bg_sel.png": "9e40",
	"./images/index_bg2.png": "f1cc",
	"./images/index_bg3.png": "8680",
	"./images/index_bg4.png": "8ba9",
	"./images/index_btn1.png": "2b0d",
	"./images/index_btn2.png": "eeea",
	"./images/index_wait_next.png": "2be2",
	"./images/info_bg1.png": "469d",
	"./images/info_bk4.png": "e332",
	"./images/input-bg.png": "dc75",
	"./images/input_bg.png": "3854",
	"./images/item_bkg1.png": "6ecd",
	"./images/item_bkg2.png": "caa5",
	"./images/item_blue.png": "46f5",
	"./images/item_blue2.png": "81ef",
	"./images/item_golden.png": "0538a",
	"./images/item_golden2.png": "4e9b",
	"./images/item_purple.png": "224c",
	"./images/item_purple2.png": "0315",
	"./images/item_red.png": "37d8",
	"./images/item_red2.png": "60ed",
	"./images/jd.png": "d036",
	"./images/join_btn.png": "9982",
	"./images/join_btn_end.png": "3646",
	"./images/joined.png": "155f",
	"./images/k1.png": "849a",
	"./images/k10.png": "6c83",
	"./images/k11.png": "959b",
	"./images/k12.png": "abd8",
	"./images/k13.png": "6406",
	"./images/k14.png": "c4c3",
	"./images/k15.png": "560c",
	"./images/k16.png": "4efa",
	"./images/k17.png": "75b0",
	"./images/k18.png": "43eb",
	"./images/k19.png": "fff8",
	"./images/k2.png": "379a",
	"./images/k20.png": "7a44",
	"./images/k21.png": "f42b",
	"./images/k22.png": "94c3",
	"./images/k23.png": "e3aa",
	"./images/k24.png": "c5c4",
	"./images/k25.png": "224a",
	"./images/k26.png": "ac27",
	"./images/k27.png": "2a87",
	"./images/k28.png": "2f33",
	"./images/k29.png": "e5d9",
	"./images/k3.png": "8a20",
	"./images/k30.png": "20b8",
	"./images/k31.png": "b8e9",
	"./images/k32.png": "bf1c",
	"./images/k33.png": "a22c",
	"./images/k34.png": "5f8d",
	"./images/k35.png": "3c84",
	"./images/k36.png": "f53b",
	"./images/k37.png": "58b8",
	"./images/k38.png": "c7e4",
	"./images/k39.png": "19bb",
	"./images/k4.png": "2920",
	"./images/k40.png": "79e4",
	"./images/k41.png": "50db",
	"./images/k42.png": "e3b4",
	"./images/k43.png": "18a0",
	"./images/k44.png": "4757",
	"./images/k45.png": "55db",
	"./images/k46.png": "d6ac",
	"./images/k47.png": "6d16",
	"./images/k5.png": "95e2",
	"./images/k6.png": "16a3",
	"./images/k7.png": "fd93",
	"./images/k8.png": "5bc1",
	"./images/k9.png": "8115",
	"./images/large_dialog.png": "4169",
	"./images/large_dialog_close.png": "3da9",
	"./images/large_dialog_top3.png": "7944",
	"./images/large_submit_btn.png": "390b",
	"./images/left_prod_box_mask.png": "62eb",
	"./images/lightning_img.gif": "31e0",
	"./images/line.png": "fe82",
	"./images/line1.png": "352b",
	"./images/line10.png": "4c1b",
	"./images/line11.png": "3f39",
	"./images/line12.png": "4ee2",
	"./images/line13.png": "26de",
	"./images/line14.png": "c4d6",
	"./images/line15.png": "9f65",
	"./images/line16.png": "fd85",
	"./images/line17.png": "0704",
	"./images/line2.png": "768d",
	"./images/line3.png": "b141",
	"./images/line4.png": "c8f7",
	"./images/line5.png": "fa768",
	"./images/line6.png": "bcba",
	"./images/line7.png": "4f41",
	"./images/line8.png": "872d",
	"./images/line9.png": "34d9",
	"./images/link-icon.png": "dc2f",
	"./images/list-bottom-light.png": "95ef",
	"./images/list-icon.png": "e753",
	"./images/list_box_bottom_bg.png": "704b",
	"./images/list_box_top_bg.png": "4e13",
	"./images/login_n.png": "123d",
	"./images/login_register.png": "2c5d",
	"./images/logo.png": "9d64",
	"./images/logo1.png": "b189",
	"./images/logout_btn.png": "0dee",
	"./images/lose_bg1.png": "bc71",
	"./images/lucky_bk_c1.png": "bec8",
	"./images/lucky_bk_p1.png": "e896",
	"./images/lucky_bk_p2.png": "856e",
	"./images/lucky_bk_p3.png": "d630",
	"./images/main-link-bg.png": "fe77",
	"./images/main_account.png": "6f6b",
	"./images/mask_bg3.png": "3b9c",
	"./images/mask_img1.png": "b3cd",
	"./images/minus-icon.png": "8f40",
	"./images/mobile-icon.png": "fc0f",
	"./images/more.png": "6664",
	"./images/mouth_bg.png": "6e02",
	"./images/msg-bg.png": "a183",
	"./images/n2_img1.png": "9e32",
	"./images/n_shop_bg1.png": "ea6a",
	"./images/nav/kf.png": "1a22",
	"./images/nav/mall.png": "dfcc",
	"./images/nav/msg.png": "1e31",
	"./images/nav/rank.png": "9fd0",
	"./images/nav/welfare.png": "2731",
	"./images/nav_2_0.gif": "4319",
	"./images/nav_2_1.gif": "b6f3b",
	"./images/nav_2_10.png": "3fa6",
	"./images/nav_2_12.png": "32ab",
	"./images/nav_2_21 - 副本.png": "292c",
	"./images/nav_2_21.png": "69f5",
	"./images/nav_2_22.gif": "9980",
	"./images/nav_2_3.gif": "f0ee",
	"./images/nav_2_31.png": "801e",
	"./images/nav_2_32.png": "a1f4",
	"./images/nav_btn_bg1.png": "715d",
	"./images/nav_index1.gif": "39dd",
	"./images/nav_item_bg1-active.png": "a65b",
	"./images/nav_item_bg1.png": "1eaa",
	"./images/nav_item_bg1_no_active.png": "ec8a",
	"./images/nav_item_bg2-active.png": "32ab9",
	"./images/nav_item_bg2.png": "6611",
	"./images/nav_item_bg2_no_active.png": "c8fa",
	"./images/nav_item_bg3-active.png": "97b2",
	"./images/nav_item_bg3_no_active.png": "ec6e",
	"./images/nav_item_bg4-active.png": "0fc6",
	"./images/nav_item_bg4_no_active.png": "555e",
	"./images/nav_sel.png": "10fe",
	"./images/nav_select.png": "6296",
	"./images/need_login1.png": "0279",
	"./images/new_ch_tab_bg1.png": "9247",
	"./images/new_ch_tab_bg2.png": "d7c4",
	"./images/no_data.png": "9684",
	"./images/number.png": "22f7",
	"./images/number_box.png": "af00",
	"./images/number_show_bg.png": "b8e4",
	"./images/open-box.png": "f169",
	"./images/open-bp.png": "26dea",
	"./images/open-record.png": "a74b",
	"./images/open_btm.png": "0407",
	"./images/open_btn.png": "7706",
	"./images/open_top.png": "6b95",
	"./images/opening_box_bg.png": "bbfd",
	"./images/order-item.png": "c19a",
	"./images/other-link-bg.png": "4f87",
	"./images/ouhuang.png": "0b5e",
	"./images/ouhuang1.png": "0d3b",
	"./images/page_bkg.png": "17e2",
	"./images/page_ct_bk1.png": "1ffe",
	"./images/page_ct_bk2.png": "e11c",
	"./images/page_ct_bk3.png": "eee4",
	"./images/pay_item_bg2.png": "261a",
	"./images/pay_item_bg_sel.png": "8cdd",
	"./images/pay_qr_outer_bg.png": "cb01",
	"./images/pay_size1.png": "d142",
	"./images/pay_size10.png": "3741",
	"./images/pay_size11.png": "7b43",
	"./images/pay_size12.png": "e3c3",
	"./images/pay_size2.png": "472b",
	"./images/pay_size3.png": "e5f8",
	"./images/pay_size4.png": "3699",
	"./images/pay_size5.png": "e6ed",
	"./images/pay_size6.png": "a9f13",
	"./images/pay_size7.png": "650e",
	"./images/pay_size8.png": "c3a7",
	"./images/pay_size9.png": "8158",
	"./images/pay_size_sel1.png": "b363",
	"./images/pay_size_sel10.png": "18ec",
	"./images/pay_size_sel11.png": "a929",
	"./images/pay_size_sel12.png": "a0c3",
	"./images/pay_size_sel2.png": "e034",
	"./images/pay_size_sel3.png": "3f88",
	"./images/pay_size_sel4.png": "4021",
	"./images/pay_size_sel5.png": "f4b1",
	"./images/pay_size_sel6.png": "56fe",
	"./images/pay_size_sel7.png": "50d2",
	"./images/pay_size_sel8.png": "aca0",
	"./images/pay_size_sel9.png": "e5c8",
	"./images/pay_tab_sel.png": "9054",
	"./images/percent-bar-active.png": "524d",
	"./images/percent-bar.png": "f6545",
	"./images/percent-button.png": "7612",
	"./images/pi.png": "3857",
	"./images/pk_img.gif": "2dbf",
	"./images/plus-icon.png": "4413",
	"./images/point_bg.png": "4391",
	"./images/popup_bottom_bg.png": "90e1",
	"./images/prize_box.png": "44f9",
	"./images/prize_btn2.png": "2954",
	"./images/prize_divider.png": "ffb3",
	"./images/prize_frag.png": "2659",
	"./images/prod-tag.png": "7ef3",
	"./images/prod_golden_item.png": "ccbc",
	"./images/prod_item.png": "960c",
	"./images/prod_item_def.png": "6f5e",
	"./images/prod_item_sel.png": "eee9",
	"./images/prod_item_sel_1.png": "4ee8",
	"./images/prod_list_title.png": "b2f6",
	"./images/progress_box_bg.png": "7d7f",
	"./images/question-icon.png": "993c",
	"./images/question1-icon.png": "3fb0",
	"./images/question2-icon.png": "3366",
	"./images/rank-1.png": "1255",
	"./images/rank-2.png": "a8e2",
	"./images/rank-3.png": "d35f",
	"./images/ready_img.png": "f127",
	"./images/realNameBtn.png": "4230",
	"./images/recharge_btn.png": "3426",
	"./images/record-bg.png": "14c4",
	"./images/record_item_sel.png": "9b16",
	"./images/recycle-icon.png": "97c4",
	"./images/recycle1-icon.png": "47a5",
	"./images/red-line.png": "089e",
	"./images/red.png": "5be9",
	"./images/register-icon.png": "1216",
	"./images/res_fail.png": "0862",
	"./images/res_win.png": "c4bb",
	"./images/right-icon.png": "5b7d",
	"./images/right-sel-icon.png": "dd02",
	"./images/right_icon.png": "9dd7",
	"./images/right_prod_box_bg.png": "7d7c",
	"./images/roll.png": "da38",
	"./images/roll_item.png": "4998",
	"./images/roll_item2.png": "ee47",
	"./images/room_bg1.png": "7e4b",
	"./images/room_end2.png": "b8b4",
	"./images/room_ready3.png": "c10b",
	"./images/room_run2.png": "46d7",
	"./images/room_wait2.png": "0ed2",
	"./images/room_wait3.png": "7f06",
	"./images/rotate_img.png": "69ff",
	"./images/rule_bg2.png": "6316",
	"./images/rule_bg3.png": "1768",
	"./images/run-active.png": "bce4",
	"./images/s_commit_btn.png": "fbdf",
	"./images/s_commit_btn2.png": "c7b3",
	"./images/safe-icon.png": "9276",
	"./images/sale-icon.png": "091c",
	"./images/search-icon.png": "9c4d",
	"./images/search_box_bg.png": "045b",
	"./images/sell.png": "ef0f",
	"./images/set_invite_code_img.png": "0c15",
	"./images/shadow_line.png": "a2c3",
	"./images/shop_bg2.png": "1eba",
	"./images/shop_bg4.png": "8cc4",
	"./images/shop_bg5.png": "1d0f",
	"./images/shop_bg6.png": "70e2",
	"./images/shop_bg7.png": "e375",
	"./images/shop_bg777.png": "b9fb",
	"./images/shop_bg8.png": "e2a8",
	"./images/shop_btn1.png": "1e8e",
	"./images/show_prize.png": "c606",
	"./images/slider__button.png": "b1a3",
	"./images/split.png": "405e",
	"./images/srcoll_box_bottom_line.png": "9755",
	"./images/st_tab1.png": "1ba2",
	"./images/st_tab2.png": "52bc",
	"./images/steam.png": "7c55",
	"./images/sub_number_list_item_bg_3.png": "8b34",
	"./images/submit_btn.png": "86bc",
	"./images/submit_btn_bg.png": "db3b",
	"./images/success_message_bg.png": "b2b0",
	"./images/sum_bk1.png": "5533",
	"./images/sum_bk2.png": "80f8",
	"./images/switch-bar.png": "e145",
	"./images/switch-handle.png": "200c",
	"./images/switch_bg.png": "b858",
	"./images/system-icon.png": "811d",
	"./images/tab-bg.png": "d9e1",
	"./images/tab-left.png": "27da",
	"./images/tab-wrap-sel.png": "9147",
	"./images/tab-wrap.png": "949a",
	"./images/tab_bkg.png": "4f7f",
	"./images/tab_item.png": "938b",
	"./images/tab_item_bg1.png": "db5b",
	"./images/tab_item_bg3.png": "6a0f",
	"./images/tab_item_def.png": "5c6b",
	"./images/tab_item_sel.png": "203c",
	"./images/tab_short.png": "fbe7",
	"./images/tab_short_active.png": "c972",
	"./images/table-bg.png": "5cd1",
	"./images/table_bottom_shadow_bgpng.png": "ed13",
	"./images/table_header.png": "0924e",
	"./images/table_header_bg.png": "e565",
	"./images/table_header_bg2.png": "1c1c",
	"./images/table_header_bg_1.png": "fcac",
	"./images/table_header_bg_2.png": "95a3",
	"./images/table_row_sel.png": "1863",
	"./images/take_back_btn.png": "36e9",
	"./images/takeback_btn.png": "cca6",
	"./images/ten_item_bg2.png": "e045",
	"./images/test.png": "9165",
	"./images/text_bg.png": "aaa2",
	"./images/text_title_bg.png": "33b7",
	"./images/title.png": "35cc",
	"./images/title_1.png": "a855",
	"./images/title_2.png": "b9bd",
	"./images/title_bg.png": "2140",
	"./images/top-box-classic.png": "a4c1",
	"./images/top-box-fight.png": "4adf",
	"./images/top-box-lucky.png": "7b4e",
	"./images/top-info.png": "69c3",
	"./images/top-row-sel.png": "8bee",
	"./images/top-row.png": "60d8",
	"./images/top_bg.png": "2c26",
	"./images/top_bkg.png": "c8bb",
	"./images/top_box_bg.png": "19ab",
	"./images/top_box_bg1.png": "9c31",
	"./images/top_box_bg2.png": "28c1",
	"./images/top_img.png": "cf6d",
	"./images/trace_light.png": "99de",
	"./images/type_tag_bg.png": "8604",
	"./images/user-bg.png": "71a1",
	"./images/user_index_page_bg.png": "7184",
	"./images/user_list_big_bg.png": "1946",
	"./images/user_lose_top2.png": "055c",
	"./images/user_lose_top3.png": "88d7",
	"./images/user_ready_top2.png": "76e9",
	"./images/user_wait_top2.png": "f4d6",
	"./images/user_win_top2.png": "3941",
	"./images/user_win_top3.png": "b27d",
	"./images/vip/0.png": "e426",
	"./images/vip/vip_anim.gif": "e692",
	"./images/vip_dialog_table_header_bg.png": "05bc",
	"./images/vip_dialog_tb_item_sel.png": "ec51",
	"./images/vip_dialog_top_bg.png": "e221",
	"./images/voice_bkg.png": "eef9",
	"./images/wait_anim.gif": "6cc8",
	"./images/wait_img.png": "d35a",
	"./images/warning.png": "e57e",
	"./images/wechat.png": "37c4",
	"./images/win2_box_bg2.png": "9a62",
	"./images/win_bg1.png": "4df0",
	"./images/win_bg3.png": "05b3",
	"./images/win_bg_1.png": "ed09",
	"./images/win_bg_2.png": "29d0",
	"./images/win_ic1.png": "d54e",
	"./images/winner_head.png": "1d4b",
	"./integral.png": "060a",
	"./item_light.png": "7f3e",
	"./jiaru.png": "b6de",
	"./jiaru2.png": "cd36",
	"./jin.png": "e417",
	"./jiuxu.png": "0847",
	"./jsjj.jpg": "01cf",
	"./jsjj.png": "c8ae",
	"./kf_bg.png": "cf7d",
	"./knapsack/1.png": "6198",
	"./knapsack/10.png": "6706",
	"./knapsack/11.png": "4714",
	"./knapsack/13.png": "6447",
	"./knapsack/14.png": "3be5",
	"./knapsack/15.png": "5013",
	"./knapsack/2.png": "f2f5",
	"./knapsack/4.png": "aab2",
	"./knapsack/5.png": "711a",
	"./knapsack/6.png": "afe5",
	"./knapsack/7-1.png": "e989",
	"./knapsack/7.png": "7578",
	"./knapsack/8.png": "fc84",
	"./knapsack/9.png": "994a",
	"./level-active-bar.png": "82d2",
	"./loginBtn.png": "8ff8",
	"./logo.png": "cf05",
	"./logo/log.png": "234a",
	"./logo/logo.jpg": "fe9c",
	"./logo/logo.png": "81a5",
	"./logo/微信图片_20240708223032-恢复的-恢复的.jpg": "e6c4",
	"./logo/未标题-1_画板 1.jpg": "04cb",
	"./luck.png": "1d7b",
	"./luckweapon.png": "f0d6",
	"./lucky-room-center-bg.png": "65b1",
	"./luckyJewelry_bg.png": "de60",
	"./lv.png": "d706",
	"./main-btn-bg-active.png": "4ae2",
	"./main-btn-bg.png": "2e39",
	"./mall.png": "67d6",
	"./mall_sel2.png": "fea0",
	"./mine-bg.png": "c0b1",
	"./mine.png": "8350",
	"./mine_sel2.png": "97ed",
	"./moba.png": "946d",
	"./moba1.png": "5bdb",
	"./money.png": "875b",
	"./need_login.png": "7c21",
	"./notice-bar.png": "4825",
	"./num1.png": "e1cf",
	"./num2.png": "8a73",
	"./num3.png": "9e7a",
	"./num4.png": "0360",
	"./num5.png": "6276",
	"./open-btn-bg2-D3rUtn-q.png": "63bd",
	"./open/1.png": "9fb5",
	"./open/2.png": "69cb",
	"./open/3.png": "d455",
	"./open/4.png": "abf1",
	"./open/Slice 3 (3).png": "7ce8",
	"./openbox.jpg": "9c24",
	"./openbox.png": "0ea4",
	"./pinxiangBottom_text_bg.png": "5b32",
	"./pinxiangBottom_top.png": "73d3",
	"./pkHome/1.png": "e4e7",
	"./pkHome/10.png": "f62c",
	"./pkHome/11.png": "234b",
	"./pkHome/12.png": "0485",
	"./pkHome/13.png": "49013",
	"./pkHome/14.png": "7a1c",
	"./pkHome/15.png": "01e0",
	"./pkHome/16.png": "725b",
	"./pkHome/2.png": "ab1f",
	"./pkHome/3.png": "9994",
	"./pkHome/4.png": "6366",
	"./pkHome/5.png": "f8d3",
	"./pkHome/6.png": "e48b",
	"./pkHome/7.png": "f00d",
	"./pkHome/8.png": "c59f",
	"./pkHome/b1-1.png": "4d6b",
	"./pkHome/b1.png": "491b",
	"./pkHome/b2-1.png": "9bdf",
	"./pkHome/b2.png": "6804",
	"./pkHome/b3-1.png": "8385",
	"./pkHome/b3.png": "e470",
	"./pk_center_user_bg.png": "bda8",
	"./pk_player_bg.png": "bfd4",
	"./pk_top_bg.png": "f298",
	"./rankbg.png": "bf12",
	"./recharge-btn.png": "ef3c",
	"./recharge.jpg": "ed8b",
	"./recharge.png": "9ca4",
	"./recharge_sel2.png": "51b0",
	"./red.png": "d970",
	"./red1.png": "0e60",
	"./roll-official-bg-DRp1UF5D.png": "2e2b",
	"./roll-official-bg-DRp1UF5D.pxr": "562b",
	"./roll.jpg": "c789",
	"./roll.png": "f774",
	"./roll/1-1.png": "81cf",
	"./roll/1.png": "09a5",
	"./roll/2-1.png": "eeb1",
	"./roll/2.png": "4ee27",
	"./roll/3-1.png": "dc33",
	"./roll/3.png": "7962",
	"./roll/5.png": "a129",
	"./roll/6.png": "2472",
	"./roll/7.png": "abdb",
	"./roll/8.png": "9619a",
	"./roll/9.png": "cc8c",
	"./roll/roll-btn.png": "a0c2",
	"./roll_jieshu.png": "85ff",
	"./roll_serch.png": "10a3",
	"./roll_status.png": "ba2e",
	"./room-bottom.png": "d9ee",
	"./room-content.png": "acd1",
	"./room-top.png": "b885",
	"./room_bg.png": "9f5f",
	"./room_bg2.png": "3132",
	"./room_btn_yjs.png": "7222",
	"./sound/bgm.mp3": "d287",
	"./sound/bgm_battle.mp3": "d1e9",
	"./sound/bgm_box.mp3": "3847",
	"./sound/box_anim_battle.mp3": "bca3",
	"./sound/box_anim_s.mp3": "0d28",
	"./sound/box_open.mp3": "4cdc",
	"./sound/box_select.mp3": "8f8e",
	"./sound/box_switch.mp3": "b9aa",
	"./sound/click.mp3": "edb6",
	"./sound/dialog_close.mp3": "a3c0",
	"./sound/dialog_open.mp3": "5196",
	"./sound/door_close.mp3": "6b0c",
	"./sound/door_open.mp3": "90c9",
	"./sound/index_count.mp3": "1e2b",
	"./sound/index_line.mp3": "934f",
	"./sound/lucky_anim1.mp3": "1543",
	"./sound/lucky_slide.mp3": "552a",
	"./sound/op_fail.mp3": "e44b",
	"./sound/pk_anim_stop.mp3": "8170",
	"./sound/pk_anim_wait.mp3": "2647",
	"./sound/pk_down.mp3": "e4c6",
	"./sound/pk_join.mp3": "1575",
	"./sound/pk_pull.mp3": "a374",
	"./sound/pk_tab.mp3": "cc60",
	"./status_btn_active.png": "d4d9",
	"./style/bt_tab.scss": "281d",
	"./style/digit_view2.scss": "6561",
	"./style/header.scss": "114c",
	"./style/iconfont.css": "b068",
	"./style/iconfont.ttf": "5eb8",
	"./style/modal.scss": "fefb",
	"./style/recharge copy.scss": "e697",
	"./style/room_item.scss": "9f1c",
	"./style/success copy.css": "85e7e",
	"./style/success.scss": "a89c",
	"./tab-active.png": "59e4",
	"./tab-select-bg-DCl8rbkb.png": "5ced",
	"./tabbars/tab_charge.png": "b444",
	"./tabbars/tab_charge_sel.png": "7ddd",
	"./tabbars/tab_home.png": "c13a",
	"./tabbars/tab_home_sel.png": "803b",
	"./tabbars/tab_mine.png": "b48b",
	"./tabbars/tab_mine_sel.png": "e3d1",
	"./tabbars/tab_package.png": "47ff",
	"./tabbars/tab_package_sel.png": "46bb",
	"./tabbars/tab_share.png": "bed7",
	"./tabbars/tab_share_sel.png": "954c",
	"./tuiguangbg.png": "0ed9",
	"./wei.png": "d869",
	"./wlogo.png": "52eb",
	"./yingjia.png": "b851",
	"./yun.png": "a990",
	"./zhi.png": "ac4a",
	"./zmqx.jpg": "7b31",
	"./zmqx.png": "cbd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";